import React from 'react';
import { useTranslation } from 'react-i18next';
import { Receipt } from 'lucide-react';

import { useAuth } from '../../context/AuthContext';

/**
 * The invoicing pages exist for providers only (D14). A building that opens
 * the URL by hand gets the section's own «not found», not the page — the API
 * would refuse it with 403 anyway, and this way it is never even asked.
 */
export function ProviderOnly({ children }: { children: React.ReactNode }) {
  const { t } = useTranslation();
  const { entityType } = useAuth();
  if (entityType !== 'service_provider') {
    return (
      <div className="flex flex-col items-center justify-center rounded-xl border border-border bg-card p-12 text-center">
        <Receipt className="mb-4 h-16 w-16 text-muted-foreground" />
        <h2 className="mb-2 text-xl font-semibold text-foreground">{t('invoices.notFoundTitle')}</h2>
        <p className="max-w-md text-muted-foreground">{t('invoices.notFoundBody')}</p>
      </div>
    );
  }
  return <>{children}</>;
}
